import { TiersTypeData } from '../types/types';

// Check if a tiers is a client or a supplier
export const isClient = (t: TiersTypeData[]): boolean => {
	return t?.some((type) => type.code === 'CLI');
};

export const isSupplier = (t: TiersTypeData[]): boolean => {
	return t?.some((type) => type.code === 'FOU');
};
